<template>
    <div class="practiceMode">
        <div class="practiceModeTitle done4">{{ title }}</div>
        <div v-if="modeDialogType == 1" class="practiceNumBox">
            <div class="section borderRadius8  practiceNum">
                <div class="sectionLi done3" @click="practiceClick">
                    <span class="sectionCon">练习次数 <img src="@/assets/images/icon-line.png" alt=""></span>
                    <span class="sectionValue done3">{{ exerciseData.count || 0 }}</span>
                </div>
            </div>
            <div class="section borderRadius8 backgroundPracticeNum sectionNum">
                <div class="sectionLi">
                    <span>及格次数</span>
                    <span class="sectionValue">{{ exerciseData.passNum || 0 }}</span>
                </div>
                <div class="sectionLi">
                    <span>平均分数</span>
                    <span class="sectionValue">{{ exerciseData.average || 0 }}</span>
                </div>
                <div class="sectionLi">
                    <span>最高分数</span>
                    <span class="sectionValue">{{ exerciseData.maxScore || 0 }}</span>
                </div>
            </div>
        </div>
        <div class="modeBox">
            <div class="modeLi borderRadius8" @click="selectMode('1')">
                <img src="@/assets/images/homeWork/exam.png" alt="">
                <div class="modeLiTitle">考试模式</div>
                <div class="modeLiDes">提交试卷后显示成绩与解析 <span v-if="modeDialogType == 1">（简答题不计分）</span></div>
            </div>
            <div class="modeLi borderRadius8" @click="selectMode('2')">
                <img src="@/assets/images/homeWork/mockExam.png" alt="">
                <div class="modeLiTitle">逐题模式</div>
                <div class="modeLiDes">每答完一题立即显示答案和解析<span v-if="modeDialogType == 1">（简答题不计分）</span></div>
            </div>

        </div>
        <div class="closeImg" @click="close">
            <img src="@/assets/images/homeWork/close.png" alt="">
        </div>
    </div>
</template>

<script>
export default {
    props: ['title', 'modeDialogType', 'exerciseData'],
    data() {
        return {

        }
    },
    methods: {
        practiceClick() {
            this.$emit('practiceClick')
        },
        selectMode(type) {
            this.$emit('selectMode', type)
        },
        close() {
            this.$emit('close')
        }
    }
}
</script>

<style lang="scss" scoped>
.practiceMode {
    padding: 24px 16px 58px;
    box-sizing: border-box;
    position: relative;
    .practiceModeTitle {
        width: 100%;
        text-align: center;
        font-size: 18px;
        font-weight: 600;
        margin-bottom: 12px;
    }
    .practiceNumBox {
        display: flex;
        .practiceNum {
            margin-right: 8px;
            width: auto;
            background-color: #EAF1FF;
        }
        .sectionNum {
            flex: 1;
        }
    }
    .modeBox {
        margin-top: 12px;
        display: flex;
        justify-content: space-between;
        .modeLi {
            width: calc(50% - 8px);
            border: 1px solid #F0F4F5;
            box-sizing: border-box;
            padding: 16px;
            font-size: 12px;
            color: #848586;
            img {
                width: 24px;
                height: 24px;
            }
            .modeLiTitle {
                margin: 4px 0 8px;
                font-size: 14px;
                color: #202020;
            }
        }
    }
    .closeImg {
        position: absolute;
        right: 16px;
        top: 24px;
        width: 24px;
        height: 24px;
        img {
            width: 100%;
        }
    }
}

.section {
    width: 100%;
    box-sizing: border-box;
    padding: 8px;
    display: flex;
    justify-content: space-around;
    .sectionLi {
        display: flex;
        flex-direction: column;
        align-items: center;
        color: #848586;
        font-size: 13px;
        .sectionValue {
            color: #202020;
            font-size: 15px;
            margin-top: 4px;
            font-weight: 600;
        }
        .sectionCon {
            display: flex;
            align-items: center;
            img {
                width: 16px;
                height: 16px;
            }
        }
    }
}
.done1 {
    color: #FF7D00;
}
.done2 {
    color: #10B881;
}
.done3 {
    color: #286BFF !important;
}
.done4 {
    color: #202020;
}
.backgroundPracticeNum {
    background-color: #F4F6F6;
}


.borderRadius8 {
    border-radius: 8px;
}
</style>